import { createAction } from '@reduxjs/toolkit'

import type { Model } from '../../types'

export const authenticationLoginSuccess = createAction<Model.Token>('authentication/login/success')
export const authenticationLogout = createAction<{ skipSessionDelete?: boolean }>(
  'authentication/logout'
)
export const authenticationCurrentUserSuccess = createAction('authentication/current-user/success')
export const authenticationVerifyOnboarding = createAction('authentication/onboarding/verify')
